import Vinos1000 from '../../../resources/images/resizedBeer/Vinos1000.png';
import carta7 from '../../../resources/images/resizedResto/carta7.png';
import TwoSectionTable from './TwoSectionTable/TwoSectionTable';

const portillo = 9900;
const perdices = 12900;
const andeluna1300 = 10500;
const andelunaR = 9900;
const santaJulia = 9900;

const vinoConfig = {
  title: 'Vinos',
  engTitle: 'Wines',
  component: TwoSectionTable,
  imgLg: Vinos1000,
  imgSm: Vinos1000,
  img: carta7,
  subSections: [
    {
      title: 'Malbec',
      items: [
        { text: 'El Gran Enemigo', price: 79000 },
        { text: 'Salentein Reserva malbec', price: 22000 },
        // { text: 'Piedra Negra (reserva)', price: 16500 },
        // { text: 'Piedra Negra Alta', price: 13500 },
        // { text: 'Laureano Gomez (reserva)', price: 14800 },
        { text: 'Santa julia', price: `${santaJulia}` },
        { text: 'Andeluna 1300', price: `${andeluna1300}` },
        { text: 'Andeluna Raices', price: `${andelunaR}` },
        { text: 'Partridge', price: 8900 },
        { text: 'Partridge 3/8', price: 6900 },
        { text: 'Portillo', price: `${portillo}` },
        { text: 'Luigi Bosca', price: 26000 },
        { text: 'Luigi Bosca de sangre', price: 45000 },
        { text: 'Perdices', price: `${perdices}` },
        // { text: 'Don Valentin', price: 7900 },
        // { text: 'Cuesta madero', price: 6000 },
        { text: 'Medalla (Trapiche)', price: 24900 },
        { text: 'Gran Medalla (Trapiche)', price: 94900 },
      ],
    },
    {
      title: 'Pinot Noir',
      items: [
        { text: 'Luigi Bosca', price: 30000 },
        { text: 'Salentein', price: 22000 },
      ],
    },
    {
      title: 'Cabernet',
      items: [
        // { text: 'Petit Fleur Cabernet Franc', price: 22000 },
        { text: 'Salentein Reserva Cabernet Franc', price: 22000 },
        { text: 'Ala Colorada (Las Perdices', price: 25000 },
        { text: 'Perdices', price: `${perdices}` },
        { text: 'Portillo', price: `${portillo}` },
        { text: 'Andeluna Raices', price: `${andelunaR}` },
        { text: 'Andeluna 1300', price: `${andeluna1300}` },
        { text: 'Luigi Bosca', price: 26000 },
        // { text: 'Enora', price: 700 },

        // { text: 'Chac Chac', price: 7900 },
      ],
    },
    {
      title: 'Vinos Blancos',
      items: [
        //{ text: 'Latitud 33 (Sauvignon Blanc)', price: 490 },
        // Removed Alma Mora Blend dulce per request
        // { text: 'Fond de Cave Reserva suavignon blanc', price: 12000 },
        { text: 'Casablanca (Suavignon Blanc)', price: 25000 },
        { text: 'Perdices', price: `${perdices}` },
        // { text: 'Piedra Negra Alta', price: 13500 },
        // { text: 'Piedra Negra Vuela', price: 16500 },
        { text: 'Santa julia (Chardonnay)', price: `${santaJulia}` },
        { text: 'Santa julia (Chenin dulce)', price: `${santaJulia}` },
        { text: 'Santa julia (Suavignon Blanc)', price: `${santaJulia}` },
        { text: 'Portillo (Chardonnay)', price: `${portillo}` },
        { text: 'Portillo (Sauvignon Blanc)', price: `${portillo}` },
      ],
    },
    {
      title: 'Champagne',
      items: [
        // Removed 'Navarro Correas' and 'Bianchi' per request
        { text: 'Norton', price: 19000 },
        { text: 'Norton cosecha especial', price: 29200 },
        { text: 'Las Perdices', price: 19000 },
        { text: 'Partridge', price: 19000 },
      ],
    },
  ],
};

export default vinoConfig;
